import {FC} from 'react'

import Carousel from '@/components/common/carousel/Carousel'
import {SLIDER_TRANSITION} from '@/theme/cssTransitions'
import {theme} from '@/theme/theme'
import {MOBILE_SCREENSIZE} from '@/utils/styles/breakpoints'

export const HowItWorksCarousel: FC<React.PropsWithChildren<unknown>> = ({children}) => {
  const settings = {
    infinite: false,
    speed: SLIDER_TRANSITION,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    dots: true,
    centerMode: true,
  }

  return (
    <>
      <div className="process">
        <Carousel settings={settings}>{children}</Carousel>
      </div>

      {/* Please, use global styles only if you need to override CSS from external libraries */}
      <style jsx global>{`
        .process .slick-slider {
          max-width: 900px;
        }
        .process .slick-slide > div {
          margin-right: ${theme.spacing[6]};
        }
        .process .slick-list {
          padding: 0 ${theme.spacing[5.5]} !important;
          margin-left: -${theme.spacing[5]};
          margin-right: -${theme.spacing[5]};
        }
        .process .slick-slide:last-of-type > div {
          margin-right: -${theme.spacing[5]};
        }
        @media ${MOBILE_SCREENSIZE} {
          .process .slick-list {
            margin-right: -${theme.spacing[3]};
          }
          .process .slick-slide:last-of-type > div {
            margin-right: -${theme.spacing[6]};
          }
        }
      `}</style>
    </>
  )
}
